import AsyncSelect from "react-select/async"

import AXIOS from "@/requests/_axios"

import type { FC } from "react"
import type { SingleValue } from "react-select"

export type Option = {
  value: string
  label?: string
  payload?: any
}

type Props = {
  onChange: (option: SingleValue<Option>) => void
  url: string
  searchKey: string
  valueKey?: string
  labelKey?: string
  value?: Option | null
  defaultValue?: Option | null
  label?: string
  placeholder?: string
  disabled?: boolean
  clearable?: boolean
  className?: string
  menuPlacement?: "bottom" | "top" | "auto"
  error?: boolean
  includePayload?: boolean
}

const AsyncDropdown: FC<Props> = ({
  onChange,
  value,
  defaultValue,
  label,
  placeholder,
  disabled = false,
  className,
  clearable = false,
  menuPlacement = "bottom",
  url,
  searchKey,
  valueKey,
  labelKey,
  error,
  includePayload
}) => {
  const promiseOptions = (inputValue: string) =>
    new Promise<Option[]>(resolve => {
      AXIOS.get(`${url}?${searchKey}=${inputValue}`).then(response => {
        if (response.status === 200) {
          const formattedData: Option[] = response.data.map((el: any) => ({
            value: el[valueKey || "value"],
            label: `${el[labelKey || "label"]} ${el.inn ? `(${el.inn})` : ""}`,
            ...(includePayload && {
              payload: {
                ...el
              }
            })
          }))

          resolve(formattedData)
        }
      })
    })

  return (
    <fieldset>
      {label && <legend>{label}</legend>}
      <AsyncSelect
        cacheOptions
        defaultOptions
        loadOptions={promiseOptions}
        value={value}
        onChange={onChange}
        defaultValue={defaultValue}
        placeholder={placeholder}
        isDisabled={disabled}
        className={className}
        isClearable={clearable}
        menuPlacement={menuPlacement}
        noOptionsMessage={() => <div>Нет данных</div>}
        theme={theme => ({
          ...theme,
          borderRadius: 4,
          colors: {
            ...theme.colors,
            primary25: "rgba(0,0,0,0.3)",
            primary: "rgba(0,0,0,0.8)"
          }
        })}
        styles={{
          control: base => ({
            ...base,
            "height": 45,
            "minHeight": 45,
            "borderColor": error ? "#ff002f" : base.borderColor,
            ":hover": {
              borderColor: error ? "#ff002f" : base[":hover"]?.borderColor
            }
          })
        }}
      />
    </fieldset>
  )
}

export default AsyncDropdown
